import { UI_Paragraph } from 'ui/components/1-atoms/Paragraph/Paragraph';
import { UI_RichText } from 'ui/components/1-atoms/RichText/RichText';
import { UI_Picture } from 'ui/components/1-atoms/Media/Picture/Picture';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';
import styles from './EmployeeCard.module.scss';
export interface UI_EmployeeCardProps {
	id?: string;
	image?: {
		url: string;
		altText?: string;
		focalPoint?: { left: number; top: number };
		fileType?: string;
	};
	name?: string;
	role?: string;
	email?: string;
	phoneNumber?: string;
	linkedIn?: { name: string; url: string };
	text?: string;
}

export const UI_EmployeeCard = ({ id, image, name, role, email, phoneNumber, linkedIn, text }: UI_EmployeeCardProps) => {
	return (
		<div className={styles.EmployeeCard} key={id}>
			{image && image.url && (
				<div className={styles.EmployeeCard_image}>
					<UI_Picture
						url={image.url}
						altText={image.altText}
						imageCropping="cover"
						sizes="(max-width: 768px) 100vw, (max-width: 1728px) 33vw, 575px"
						focalPoint={image.focalPoint}
						fileType={image.fileType}
					/>
				</div>
			)}
			<div className={styles.EmployeeCard_info}>
				{name && <UI_Paragraph className={styles.EmployeeCard_name}>{name}</UI_Paragraph>}
				{role && <UI_Paragraph>{role}</UI_Paragraph>}
				{email && (
					<UI_Link href={`mailto:${email}`} className={styles.EmployeeCard_email}>
						{email}
					</UI_Link>
				)}
				{phoneNumber && <UI_Link href={`tel:${phoneNumber}`}>{phoneNumber}</UI_Link>}
				{linkedIn && <UI_Link href={linkedIn.url}>{linkedIn.name}</UI_Link>}
			</div>
			{text && <UI_RichText className={styles.EmployeeCard_richText} content={text} />}
		</div>
	);
};
